import { useTranslation } from "react-i18next";
import AnimatedModal from "components/layout/motion/AnimatedModal";
import FunctionalButton from "components/layout/FunctionalButton";

interface FrontPhotoWaypointConfirmDialogProps {
    visible: boolean;
    /** Record waypoint then Take Photo */
    onConfirm: () => void;
    /** Take Photo only (no waypoint) */
    onDecline: () => void;
    /** Cancel — create neither */
    onCancel: () => void;
}

/**
 * Shown when a front-camera Take Photo is confirmed far from (or without) a prior waypoint.
 * Yes → waypoint + photo; No → photo only; close/backdrop → cancel.
 */
export const FrontPhotoWaypointConfirmDialog: React.FC<FrontPhotoWaypointConfirmDialogProps> = ({
    visible,
    onConfirm,
    onDecline,
    onCancel,
}) => {
    const { t } = useTranslation(["missions", "common"]);

    return (
        <AnimatedModal
            visible={visible}
            onClose={onCancel}
            className="max-w-md rounded-r10 bg-black100 p-6"
        >
            <h2 className="mb-3 text-h4 font-semibold">{t("dialogs.frontPhotoWaypointTitle")}</h2>
            <p className="mb-6 text-h5 text-black40">{t("dialogs.frontPhotoWaypointBody")}</p>
            <div className="flex justify-end gap-3">
                <FunctionalButton
                    title={t("common:no")}
                    className="bg-black70 px-4 py-2"
                    onClick={onDecline}
                />
                <FunctionalButton title={t("common:yes")} className="px-4 py-2" onClick={onConfirm} />
            </div>
        </AnimatedModal>
    );
};

export default FrontPhotoWaypointConfirmDialog;
